import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import i18n from '@/libs/i18n'
import { ref } from '@vue/composition-api'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useConfirmationPlanningAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { createItems } = useLambda()
  const { router } = useRouter()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const isSubmitting = ref(false)
  const collection = 'confirmation_planning'

  async function create(data) {
    if (!hasPermission('confirmation-planning', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const client_id = oid(userData.client.$oid)
      const payload = []

      data.process.value.forEach(p => {
        data.evaluated.value.forEach(e => {
          payload.push({
            client_id,
            process: oid(p),
            confirmationsPerYear: Number(data.confirmationsPerYear.value),
            evaluated: oid(e),
            history: [createInitialAuditEntry()],
          })
        })
      })

      await createItems({ collection, payload })

      showSuccessMessage(i18n.t('message.confirmation_planning_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.confirmation_planning_add_error'))
    } finally {
      router.push({ name: 'organization-confirmation-planning-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    isSubmitting,
  }
}
